import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import config from '../../../../../../config';
import { useDebounce } from '../../../../../../hooks/useDebounce';
import DateField from '../../../../../../components/DateField';
import Checkbox from '../../../../../../components/Checkbox';
import Field from '../../../../../../components/Field';

export function FilterFields(props) {
  const { filterParams, onChange, className } = props;
  const { brokerNameOrContractNumber, iisOpenDateFrom, iisOpenDateTo, isShowOnlyOpenedIis } =
    filterParams;

  const [searchText, setSearchText] = useState(brokerNameOrContractNumber);

  const now = useMemo(() => moment(), []);
  const isSearchClearable = searchText.length > 0;

  const debouncedSearchText = useDebounce(searchText, 1000);

  useEffect(() => {
    if (debouncedSearchText.length !== 1) {
      onChange({ ...filterParams, brokerNameOrContractNumber: debouncedSearchText });
    }
  }, [debouncedSearchText]);

  const handleDateChange = (filterName) => (value) => {
    onChange({
      ...filterParams,
      [filterName]: value ? value.format(config.serverDatetimeFormat) : null,
    });
  };

  const handleCheckboxChange = (value) => {
    onChange({ ...filterParams, isShowOnlyOpenedIis: value });
  };

  const handleSearchChange = (event) => setSearchText(event.target.value);
  const handleSearchClear = () => setSearchText('');

  return (
    <div className={classnames(className, `white-block_border white-block_border__bottom boo`)}>
      <div className={'row align-items-center'}>
        <div className={'col-auto'}>
          <DateField
            label={'Дата открытия'}
            startDateValue={iisOpenDateFrom}
            endDateValue={iisOpenDateTo}
            handleChangeStart={handleDateChange('iisOpenDateFrom')}
            handleChangeEnd={handleDateChange('iisOpenDateTo')}
            maxDate={now}
          />
        </div>
        <div className={'col-md col-auto mt-3'}>
          <Checkbox
            label={'Показать только активные'}
            value={isShowOnlyOpenedIis}
            onChange={handleCheckboxChange}
          />
        </div>
      </div>

      <div className={'row'}>
        <div className={'col'}>
          <Field
            placeholder={'Введите наименование брокера или номер договора'}
            onChange={handleSearchChange}
            maxLength={256}
            hasHelpWrap={false}
            value={searchText}
            className={'form_item'}
          >
            {isSearchClearable ? (
              <span className={'icon_reset search_icons'} onClick={handleSearchClear} />
            ) : (
              <span className={'icon_search search_icons'} />
            )}
          </Field>
        </div>
      </div>
    </div>
  );
}

FilterFields.propTypes = {
  filterParams: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
